export const showBetaFunctionality =
  process.env.REACT_APP_SHOW_BETA_FUNCTIONALITY === 'true';
